import { render, staticRenderFns } from "./TemplatesLanguageControl.vue?vue&type=template&id=3d79d97e&scoped=true"
import script from "./TemplatesLanguageControl.vue?vue&type=script&lang=js"
export * from "./TemplatesLanguageControl.vue?vue&type=script&lang=js"
import style0 from "./TemplatesLanguageControl.vue?vue&type=style&index=0&id=3d79d97e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d79d97e",
  null
  
)

export default component.exports